var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavRecentSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,7V9H12.89923A5.0048,5.0048,0,0,1,9,12.89923V15H7V12.89166A4.99091,4.99091,0,0,1,3.10223,8.9068l-1.51959.58289,2.00208-4,1.99792,4-1.472-.5882A3.99857,3.99857,0,1,0,7,4.1286V1H9V3.10077A5.0048,5.0048,0,0,1,12.89923,7ZM10,8.01038a2,2,0,1,1-2-2A2,2,0,0,1,10,8.01038Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavRecentSvg1);
export default __webpack_public_path__ + "static/media/nav-recent-svg-1.4c6278a23bce661ad79826abebd283ea.svg";
export { ForwardRef as ReactComponent };